// extracted by mini-css-extract-plugin
export default {"popupWrapper":"ThumbnailImageWithHover_popupWrapper__vBzcu","popupBody":"ThumbnailImageWithHover_popupBody__9lObP"};